/* eslint-disable prettier/prettier */
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { InMemoryCache } from 'apollo-cache-inmemory';
import ApolloClient from 'apollo-client';
import { ApolloProvider } from 'react-apollo';
import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { Normalize } from 'styled-normalize';
// import { split } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
// import { WebSocketLink } from 'apollo-link-ws';
// import { getMainDefinition } from 'apollo-utilities';

import { theme } from './theme';
import { ContextProvider } from './components';
import * as serviceWorker from './serviceWorker';
import AppNavigation from './navigation/AppNavigation';
import { ThemeInterface } from './theme/ThemeInterface';
import ErrorFallback from './components/ErrorFallback';
import packageJson from '../package.json';

const bugsnagClient = bugsnag({
  apiKey: 'aa2969b57a3eee2b2646855357969429',
  appVersion: packageJson.version,
});

bugsnagClient.use(bugsnagReact, React);
const ErrorBoundary = bugsnagClient.getPlugin('react');
const { REACT_APP_PRISMA_ENDPOINT = '', REACT_APP_STAGE = '' } = process.env;
console.log(process.env);
// @ts-ignore
const wsUrl = `${REACT_APP_PRISMA_ENDPOINT.includes('https') ? 'wss://' : 'ws://'}${REACT_APP_PRISMA_ENDPOINT.slice(
  // @ts-ignore
  REACT_APP_PRISMA_ENDPOINT.indexOf('://') + 3
  // @ts-ignore
)}${REACT_APP_PRISMA_ENDPOINT.includes('https') ? `/${REACT_APP_STAGE}` : ''}`;

const httpLink = new HttpLink({
  uri: REACT_APP_PRISMA_ENDPOINT,
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const GlobalStyle = createGlobalStyle`
  body, html {
    font-family: ${(props: ThemeInterface) => props.theme.fontFamily};
  }
`;

const AppWithProviders = () => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <ContextProvider>
          <>
            <Normalize />
            <AppNavigation />
            <GlobalStyle />
          </>
        </ContextProvider>
      </ThemeProvider>
    </ApolloProvider>
  </ErrorBoundary>
);

ReactDOM.render(<AppWithProviders />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.tsx